export const SENTRY_IGNORE_ERRORS: Array<string | RegExp> = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
]

export const SENTRY_DENY_URLS: Array<string | RegExp> = [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-extension:\/\//,
    /^safari-web-extension:\/\//,
    /^extension:\/\//,
]
